import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { MisTareasDocumentsContent } from './components/MisTareasDocumentsContent';

export default function MisTareasDocuments() {
    return (
        <MainContent
            component={<MisTareasDocumentsContent />}
            titulo='Mis Tareas'
            noBackground
            tableMaxWidth
        />
    );

};
